import { IEditDishRestaurantPropertiesContext } from './editDishRestaurantPropertiesContext';

export enum EditDishRestaurantPropertiesActionTypes {
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_DATA_FROM_RESTAURANT = 'SET_DATA_FROM_RESTAURANT',
	CHANGE_PRICE = 'CHANGE_PRICE',
	CHANGE_OPEN_PRICE = 'CHANGE_OPEN_PRICE',
	CHANGE_OPEN_PRICE_MAX_THRESHOLD = 'CHANGE_OPEN_PRICE_MAX_THRESHOLD',
	TOGGLE_HAS_OPEN_PRICE = 'TOGGLE_HAS_OPEN_PRICE',
	TOGGLE_IN_STOP = 'TOGGLE_IN_STOP',
	TOGGLE_IS_COMMENT_VISIBLE = 'TOGGLE_IS_COMMENT_VISIBLE',
	TOGGLE_IS_FISCALIZED = 'TOGGLE_IS_FISCALIZED',
	CHANGE_PORTION_SELECTION_MODE = 'CHANGE_PORTION_SELECTION_MODE',
	CHANGE_TAX_PERCENT = 'CHANGE_TAX_PERCENT',
	TOGGLE_IS_PROTECT_FROM_SYNC = 'TOGGLE_IS_PROTECT_FROM_SYNC',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_MODIFIER_GROUP = 'SET_MODIFIER_GROUP',
	SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA = 'SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchRestPropsData {
	type: EditDishRestaurantPropertiesActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IEditDishRestaurantPropertiesContext['needRefetchRestPropsData'];
	};
}

interface ISetAllData {
	type: EditDishRestaurantPropertiesActionTypes.SET_ALL_DATA;
	payload: {
		dishId: IEditDishRestaurantPropertiesContext['dishId'];
		dishName: IEditDishRestaurantPropertiesContext['dishName'];
		isCreatedOnPos: IEditDishRestaurantPropertiesContext['isCreatedOnPos'];
		isPortionEnabled: IEditDishRestaurantPropertiesContext['isPortionEnabled'];
		customerName: IEditDishRestaurantPropertiesContext['customerName'];
		hasSchedulePriority: IEditDishRestaurantPropertiesContext['hasSchedulePriority'];
		activationSchedule: IEditDishRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditDishRestaurantPropertiesContext['deactivationSchedule'];
		fetchedRestaurants: IEditDishRestaurantPropertiesContext['fetchedRestaurants'];
		restaurantsWithPortionsIds: IEditDishRestaurantPropertiesContext['restaurantsWithPortionsIds'];
	};
}

interface ISetIDRestaurant {
	type: EditDishRestaurantPropertiesActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IEditDishRestaurantPropertiesContext['IDSelectedRestaurant'];
		categories: IEditDishRestaurantPropertiesContext['categories'];
		price: IEditDishRestaurantPropertiesContext['price'];
		openPrice: IEditDishRestaurantPropertiesContext['openPrice'];
		openPriceMaxThreshold: IEditDishRestaurantPropertiesContext['openPriceMaxThreshold'];
		hasOpenPrice: IEditDishRestaurantPropertiesContext['hasOpenPrice'];
		inStop: IEditDishRestaurantPropertiesContext['inStop'];
		isCommentVisible: IEditDishRestaurantPropertiesContext['isCommentVisible'];
		isFiscalized: IEditDishRestaurantPropertiesContext['isFiscalized'];
		activationSchedule: IEditDishRestaurantPropertiesContext['activationSchedule'];
		taxPercent: IEditDishRestaurantPropertiesContext['taxPercent'];
		isTaxPercentProtectedFromSync: IEditDishRestaurantPropertiesContext['isTaxPercentProtectedFromSync'];
		deactivationSchedule: IEditDishRestaurantPropertiesContext['deactivationSchedule'];
		IDsSelectedModifierGroups: IEditDishRestaurantPropertiesContext['IDsSelectedModifierGroups'];
		modifierGroupsWithAdditionalData: IEditDishRestaurantPropertiesContext['modifierGroupsWithAdditionalData'];
		hasPortions: IEditDishRestaurantPropertiesContext['hasPortions'];
		portionSelectionMode: IEditDishRestaurantPropertiesContext['portionSelectionMode'];
		hasPortionBasedModGroups: IEditDishRestaurantPropertiesContext['hasPortionBasedModGroups'];
	};
}

interface ISetDataFromRestaurant {
	type: EditDishRestaurantPropertiesActionTypes.SET_DATA_FROM_RESTAURANT;
	payload: {
		categories: IEditDishRestaurantPropertiesContext['categories'];
		price: IEditDishRestaurantPropertiesContext['price'];
		openPrice: IEditDishRestaurantPropertiesContext['openPrice'];
		openPriceMaxThreshold: IEditDishRestaurantPropertiesContext['openPriceMaxThreshold'];
		hasOpenPrice: IEditDishRestaurantPropertiesContext['hasOpenPrice'];
		inStop: IEditDishRestaurantPropertiesContext['inStop'];
		isCommentVisible: IEditDishRestaurantPropertiesContext['isCommentVisible'];
		isFiscalized: IEditDishRestaurantPropertiesContext['isFiscalized'];
		taxPercent: IEditDishRestaurantPropertiesContext['taxPercent'];
		isTaxPercentProtectedFromSync: IEditDishRestaurantPropertiesContext['isTaxPercentProtectedFromSync'];
		activationSchedule: IEditDishRestaurantPropertiesContext['activationSchedule'];
		deactivationSchedule: IEditDishRestaurantPropertiesContext['deactivationSchedule'];
		IDsSelectedModifierGroups: IEditDishRestaurantPropertiesContext['IDsSelectedModifierGroups'];
		modifierGroupsWithAdditionalData: IEditDishRestaurantPropertiesContext['modifierGroupsWithAdditionalData'];
		hasPortions: IEditDishRestaurantPropertiesContext['hasPortions'];
		portionSelectionMode: IEditDishRestaurantPropertiesContext['portionSelectionMode'];
		hasPortionBasedModGroups: IEditDishRestaurantPropertiesContext['hasPortionBasedModGroups'];
	};
}

interface IChangePrice {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_PRICE;
	payload: {
		price: IEditDishRestaurantPropertiesContext['price'];
	};
}

interface IChangeOpenPrice {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_OPEN_PRICE;
	payload: {
		openPrice: IEditDishRestaurantPropertiesContext['openPrice'];
	};
}

interface IChangeOpenPriceMaxThreshold {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_OPEN_PRICE_MAX_THRESHOLD;
	payload: {
		openPriceMaxThreshold: IEditDishRestaurantPropertiesContext['openPriceMaxThreshold'];
	};
}

interface IToggleHasOpenPrice {
	type: EditDishRestaurantPropertiesActionTypes.TOGGLE_HAS_OPEN_PRICE;
}

interface IToggleInStop {
	type: EditDishRestaurantPropertiesActionTypes.TOGGLE_IN_STOP;
}

interface IToggleIsCommentVisible {
	type: EditDishRestaurantPropertiesActionTypes.TOGGLE_IS_COMMENT_VISIBLE;
}

interface IToggleIsFiscalized {
	type: EditDishRestaurantPropertiesActionTypes.TOGGLE_IS_FISCALIZED;
}

interface IChangePortionSelectionMode {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_PORTION_SELECTION_MODE;
	payload: {
		portionSelectionMode: IEditDishRestaurantPropertiesContext['portionSelectionMode'];
	};
}

interface IChangeTaxPercent {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_TAX_PERCENT;
	payload: {
		taxPercent: IEditDishRestaurantPropertiesContext['taxPercent'];
	};
}

interface IToggleIsTaxPercentProtectedFromSync {
	type: EditDishRestaurantPropertiesActionTypes.TOGGLE_IS_PROTECT_FROM_SYNC;
}

interface IChangeActivationSchedule {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditDishRestaurantPropertiesContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditDishRestaurantPropertiesContext['deactivationSchedule'];
	};
}

interface ISetModifierGroups {
	type: EditDishRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP;
	payload: {
		IDsSelectedModifierGroups: IEditDishRestaurantPropertiesContext['IDsSelectedModifierGroups'];
	};
}

interface ISetModifierGroupsWithAdditionalData {
	type: EditDishRestaurantPropertiesActionTypes.SET_MODIFIER_GROUP_WITH_ADDITIONAL_DATA;
	payload: {
		modifierGroupsWithAdditionalData: IEditDishRestaurantPropertiesContext['modifierGroupsWithAdditionalData'];
	};
}

interface ISetDataForSubmit {
	type: EditDishRestaurantPropertiesActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditDishRestaurantPropertiesContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditDishRestaurantPropertiesActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditDishRestaurantPropertiesContext['typeOfModalWindow'];
	};
}

export type TEditDishRestaurantPropertiesAction =
	| IRefetchRestPropsData
	| ISetAllData
	| ISetIDRestaurant
	| ISetDataFromRestaurant
	| IChangePrice
	| IChangeOpenPrice
	| IChangeOpenPriceMaxThreshold
	| IToggleHasOpenPrice
	| IToggleInStop
	| IToggleIsCommentVisible
	| IToggleIsFiscalized
	| IChangePortionSelectionMode
	| IChangeTaxPercent
	| IToggleIsTaxPercentProtectedFromSync
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetModifierGroups
	| ISetModifierGroupsWithAdditionalData
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
